import React from "react";

/**
 * VehicleDetailTransferCostIcon
 *
 * Icon for vehicle transfer cost detail. Used in VehicleDetailsList.
 */
const VehicleDetailTransferCostIcon: React.FC<{ className?: string }> = ({
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height="24"
    width="24"
    className={className}
  >
    <path
      stroke="currentColor"
      d="M5 18.5h2m2 0h6m2 0h2M4.25 14.894c1.691 0.28 4.591 0.606 7.75 0.606 3.16 0 6.059 -0.326 7.75 -0.606m-15.5 0A12 12 0 0 0 5.5 9.561V9.5h13v0.06c0 1.865 0.434 3.688 1.25 5.334m-15.5 0a12 12 0 0 1 -1.64 2.476l-0.111 0.13v6h2.25l0.075 -0.12a4 4 0 0 1 3.392 -1.88h7.566a4 4 0 0 1 3.392 1.88l0.075 0.12h2.25v-6l-0.111 -0.13a12.03 12.03 0 0 1 -1.639 -2.476M8.5 3.5h1M15 5V3.5M13 5V3.5M11.6 5a3 3 0 1 1 0 -3h4.813c0.347 0.492 0.815 0.885 1.36 1.142L18 3.25v0.5l-0.229 0.108A3.486 3.486 0 0 0 16.411 5H11.6Z"
      strokeWidth="1.5"
    ></path>
  </svg>
);

export default VehicleDetailTransferCostIcon;
